import { render } from "./Securities.vue?vue&type=template&id=905cc3da&ts=true"
import script from "./Securities.vue?vue&type=script&lang=ts"
export * from "./Securities.vue?vue&type=script&lang=ts"

import "./Securities.vue?vue&type=style&index=0&id=905cc3da&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__